import { render } from "./BarcodeComp.vue?vue&type=template&id=0deb4250"
import script from "./BarcodeComp.vue?vue&type=script&lang=js"
export * from "./BarcodeComp.vue?vue&type=script&lang=js"

import "./BarcodeComp.vue?vue&type=style&index=0&id=0deb4250&lang=css"
import "./BarcodeComp.vue?vue&type=style&index=1&id=0deb4250&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__